module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/folk-3c0c188bda930facff70651fd48860b8.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/folk.svg
// module id = 4ozQ
// module chunks = 24